import { cnpj } from "cpf-cnpj-validator";
export const phoneRegex = /\(\d{2}\)\s\d{5}\\-\d{4}/;
export const cnpjRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const nameSurname = /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/;

export function checkCNPJFormat(control: string): boolean | void {
  if (!cnpj.isValid(control)) {
    return;
  }
  return true;
}

export function checkSurname(control: string): boolean | void {
  if (!nameSurname.test(control)) {
    return;
  }
  return true;
}

export function phoneMask(phone: string | undefined): string {
  phone = phone as string;
  phone = phone?.replace(/[^a-z0-9]/gi, "");
  if (phone?.length === 11) {
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  if (phone?.length === 10) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return "";
}

export function cepMask(cep: string | undefined): string {
  cep = cep as string;
  cep = cep?.replace(/[^a-z0-9]/gi, "");
  if (cep) {
    return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
  }
  return "";
}

export function removeCNPJMask(cnpjValue: string): string | undefined {
  return cnpjValue.match(/\d+/g)?.join("");
}

export function returnPercent(percent: string | undefined): string {
  if (percent) {
    return `Até ${percent}% de desconto`;
  }
  return "";
}

export function returnBenefitName(
  name: string | undefined,
  percent: string | undefined
): string | undefined {
  if (name === "Desconto") {
    return `Até ${percent}% de desconto`;
  }
  return percent;
}

export function formatMedia(icon: boolean): "instagram" | "facebook" {
  return icon ? "instagram" : "facebook";
}

export function returnBackgroundColor(width: number): any {
  if (width < 1024) {
    return { backgroundColor: "#f8f9f7" };
  }
  return {};
}

export function returnSocialMediaValue(
  value: string | undefined,
  name: string | undefined
): any {
  if (value) {
    const length = value?.split("/").length;
    const aux = value?.split("/")[length - 1];
    return name === "instagram" ? `@${aux}` : `/${aux}`;
  }
  return "";
}

export function returnOnScrollBehaviour(scrollY: number): any {
  if (scrollY > 0) {
    return { top: 0, boxShadow: "0 0 3px 3px rgb(8 8 8/5%)" };
  }
  return {};
}

export function formatToCurrency(value: number | string): string {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatDate(isoDate: string) {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Os meses são indexados a partir de 0
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
